import { useProviderListingReferencesInitialPage } from "@/features/providers";
import type { CollectionWagsListing } from "@/features/listings";
import {
    MIN_OTHER_DOGS,
    type OtherDog,
    otherDogsFromReferences,
} from "./other-dogs";

export type ProviderOtherDogs =
    | { status: "loading" }
    | { status: "none"; availableOthers: number }
    | {
          status: "ready";
          dogs: OtherDog[];
          availableOthers: number;
          littermates: number;
      };

export function useProviderOtherDogs(
    dog: CollectionWagsListing,
    enabled: boolean,
): ProviderOtherDogs {
    const providerId = dog.organizationId ?? undefined;
    const query = useProviderListingReferencesInitialPage(
        enabled ? providerId : undefined,
    );
    if (!providerId) return { status: "none", availableOthers: 0 };
    if (!query.data)
        return query.isError
            ? { status: "none", availableOthers: 0 }
            : { status: "loading" };
    const result = otherDogsFromReferences({
        references: query.data.listingReferences,
        availableCount: query.data.availableCount,
        listing: {
            id: dog.id,
            status: dog.status,
            ageLabel: dog.ageLabel,
            breedNames: dog.breeds.map((breed) => breed.name),
        },
    });
    if (result.dogs.length < MIN_OTHER_DOGS)
        return { status: "none", availableOthers: result.availableOthers };
    return { status: "ready", ...result };
}
